import React from 'react';
import { Redirect } from 'react-router';
import TextField from 'material-ui/TextField';
import Paper from 'material-ui/Paper/Paper';
import {apiService} from '../../common/apiCallService';
import {baseUrl} from '../../common/config.js';
import Dialog from 'material-ui/Dialog';
import Menu from '../Menu.js'
import * as actions from '../../store/actions/index';
import { connect } from 'react-redux';
import { createVirtualPageLoad, closeVirtualPage } from '../../common/commonService'

/**
 * -:- Notes -:-
 * > create a functional component that will get the text field
 */
class TournamentOverlayTypeUpsert extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            type : 'Add',
            loading : false,
            tournamentTypeTemplates : [],
            _id : undefined,
            name : '',
            name_error : '',
            regMinsAfterStart : '',
            regMinsAfterStart_error : '',
            regExp : [],
            regExp_error : '',
            buyInFilter : '',
            buyInFilter_error : '',
            stageParams : [],
            stageParams_error : '',
            redirect : false,
            copyModalOpen : true
        }
        this.getTournamentTypeTemplates();
        if( props.match.params.id != 0 ) {
            this.getTournamentOverlayType(props.match.params.id);
        }
    }

    componentDidMount() {
        createVirtualPageLoad("/tournamentType")
      }
    
      componentWillUnmount() {
        closeVirtualPage()
      }

    buyInFilterChange = (type, value) => {
        let  min, max;
        if(type == 'max') {
            max = value
            min = this.getBuyinFilterMin();
        } else if(type == 'min') {
            max = this.getBuyinFilterMax();
            min = value
        }
        this.setState({ buyInFilter : this.processBuyInFilter(min, max) })
    }

    processBuyInFilter = ( min = '', max='' ) => {
        let filterText;
        if((min == '' || !min) && (max == '' || !max)) filterText = '';
        else if(min != '' && max != '') filterText = `bt ${min ? min : ''} ${max ? max : ''}`;
        else if(min != '') filterText = `gt ${min}`
        else if(max != '') filterText = `lt ${max}`
        return filterText
    }

    //rf : combine both methods
    getBuyinFilterMin = () => {
        let [identifier, min, max] = this.state.buyInFilter.split(' ');
        if(identifier == 'lt') min = ''
        return min ? min : ''
    }

    getBuyinFilterMax = () => {
        let [identifier, min, max] = this.state.buyInFilter.split(' ');
        if(identifier == 'lt') max = min
        return max ? max : ''
    }

    getTextField = (label,fieldName, onChange ) => {
        return(
            <div>
                <label>{label}</label>
                <input 
                    type="text"
                    value={this.state[fieldName]}
                    onChange={onChange}
                    className="form-control"
                    style = {{marginTop: '2%', marginBottom : '2%'}}
                />
                <span style={{ color : 'red' }} >
                    {this.state[fieldName+'_error']}
                </span>
            </div>
        )
    }
    getTournamentOverlayType = (_id) => {
        apiService( 
            baseUrl + '/tournamentoverlay/type/get', 
            { _id  },
            data => {
                data.type = 'Update';
                this.setState(data)
            },
            err => {
                console.log(err);
            }
        )
    }
    postData = () => {
        const {name, regMinsAfterStart, regExp, stageParams, _id} = this.state
        if(this.validateName(name) 
            && this.validateRegMinsAfterStart(''+regMinsAfterStart)
            && this.validateRegExp(regExp.join(', '))
            && this.validateStageParams(stageParams)) {
                apiService( 
                    baseUrl + '/tournamentoverlay/type/upsert', 
                    {
                        _id : this.state._id,
                        name : this.state.name,
                        regMinsAfterStart : this.state.regMinsAfterStart,
                        regExp : this.state.regExp,
                        stageParams : this.state.stageParams,
                        buyInFilter : this.state.buyInFilter
                    },
                    data => {
                        if( data.status == 'error' ) {
                            this.setState(data.errMsgs)
                        } else {
                            this.setState({redirect : true})
                        }
                    },
                    err => {
                        console.log(err);
                    }
                )  
            }
    }


    onNameChange = event => {
        const {value} = event.target;
        this.setState({ name : value }, _ => this.validateName(value))
    }

    validateName = (name) => {
        if(name.trim() == '') {
            this.setState({ name_error : 'Name Field cannot be empty' })
            return false;
        } else {
            this.setState({ name_error : '' })
            return true
        }
    }
    
    onRegMinsAfterStartChange = event => {
        const {value} = event.target;
        this.setState({ regMinsAfterStart : value }, _ => this.validateRegMinsAfterStart(value))
    }

    validateRegMinsAfterStart = (regMinsAfterStart) => {
        if(isNaN(regMinsAfterStart)) {
            this.setState({ regMinsAfterStart_error : 'regMinsAfterStart should be a number' });
            return false;
        } else if(regMinsAfterStart.trim() == '') {
            this.setState({ regMinsAfterStart_error : 'regMinsAfterStart Field cannot be empty' });
            return false;
        } else {
            this.setState({ regMinsAfterStart_error : '' });
            return true;
        }
    }

    onRegExpChange = (event) => {
        const {value} = event.target;
        this.setState({ regExp : value.split(',') }, _ => this.validateRegExp(value))
    }

    validateRegExp = (regExp) => {
        if( regExp.trim() == '' ) {
            this.setState({ regExp_error : 'regExp Field cannot be empty' })
            return false;
        } else {
            this.setState({ regExp_error : ''})
            return true;
        }
    }


    onExpectedPercentChange = (key) => {
        return (event) => {
            const {value} = event.target;
            let {stageParams} = this.state;
            stageParams[key].expectedPercent = value; 
            this.setState({stageParams}, _ => this.validateExpectedPercent(stageParams[key].expectedPercent))
        }
    }
    
    getTournamentTypeTemplates = _ => {
        this.setState({loading : true})
        apiService( 
            baseUrl + '/tournamentoverlay/type/list', 
            {},
            data => {
                let tournamentTypeTemplates = data;
                this.setState({tournamentTypeTemplates, loading : false})
            },
            err => console.log('error occured')
        )
    }

    validateExpectedPercent = expectedPercent => {
        if(expectedPercent.trim() == '') {
            this.setState({ stageParams_error : 'Expected Percent field cannot be empty' });
            return false;
        }
        else if(isNaN(expectedPercent)) {
            this.setState({ stageParams_error : 'Expected Percent field should be a number' });
            return false;
        } else {
            this.setState({ stageParams_error : '' });
            return false;
        }
    }

    addStageParams = () => {
        let {stageParams} = this.state;
        stageParams.push({expectedPercent : 0, stagePercent : 0});
        
        this.setState({ stageParams_error : '', stageParams }, _ => {
            this.validateExpectedPercent('0');
            this.validateStageParams('0');
        }) 
    }

    removeStageParams = key => {
        return event => {
            let {stageParams} = this.state;
            // console.log({key})
            stageParams.splice(key, 1); 
            this.setState({stageParams}, _ => this.validateStageParams(stageParams))
        }
    }

    validateStageParams = stageParams => {
        let isValid = true;
        if(stageParams.length == 0) {
            this.setState({ stageParams_error : 'Stage Parametre cannot be empty'})
            return false
        } else {
            this.setState({ stageParams_error : ''})
            return true
        }
    }
    onStagePercentChange = (key) => {
        return (event) => {
            const {value} = event.target;
            let {stageParams} = this.state;
                        
            stageParams[key].stagePercent = value; 
            this.setState({ stageParams }, _ => this.validateStagePercent(stageParams[key].stagePercent ))
        }
    }

    validateStagePercent = (stagePercent) => {
        let {stageParams} = this.state;
        let filteredParams = stageParams.filter(stageParam => stageParam.stagePercent == stagePercent)
        if(stagePercent.trim() == '') {
            this.setState({ stageParams_error : 'Stage Percent field cannot be empty' });
            return false;
        } else if(isNaN(stagePercent)) {
            this.setState({ stageParams_error : 'Stage Percent should be a Number' });
            return false;
        } else if(filteredParams.length > 1) {
            this.setState({ stageParams_error : 'Stage Percent must be unique' });
            return false;
        } else {
            this.setState({ stageParams_error : '' });
            return true;
        }
    }
    

    stagePercentExists = ( stagePercent, stageParams ) => {
        if( stageParams.findIndex(stageParam => stageParam.stagePercent == stagePercent) < 0 ) return false
        else return true
    }

    handleClose = () => {
        this.setState({copyModalOpen : false})
    }

    render() {
        this.props.setHeaderTitle(`${this.state.type} Tournament Type`)
        return(
            <div>
                {this.state.redirect && (<Redirect to={'/tournamenttype'}/>)}
                <div>
                    <Paper zDepth={1} rounded={false} className="resp-paper" style={{width : '75%',marginLeft:'auto',marginRight:'auto'}}>
                        <div className = 'container'>
                            <div className = 'row' style={{marginLeft:'5%',marginRight: '5%',padding:'0'}}>
                                <div className = 'col-sm-6' data-e2e="name" >
                                    {this.getTextField('Name : ', 'name', this.onNameChange)}              
                                </div>
                                <div className = 'col-sm-6' data-e2e="Late Registration Minutes">
                                    {this.getTextField( 'Late Registration Minutes : ', 'regMinsAfterStart', this.onRegMinsAfterStartChange )}              
                                </div>
                            </div>
                            <div className = 'row' style={{marginLeft:'5%',marginRight: '5%',padding:'0'}}>
                                <div className = 'col-sm-12' data-e2e="Regular expression">
                                    <label>Regular expression : </label>
                                    <input 
                                        type="text"
                                        value = {this.state.regExp.join(',')} 
                                        onChange={this.onRegExpChange}
                                        className="form-control" 
                                        style = {{marginTop: '2%', marginBottom : '2%'}}
                                    />
                                    <span style={{ color : 'red' }} >
                                        {this.state.regExp_error}
                                    </span>
                                </div>
                            </div>
                            <div className = 'row' style={{marginLeft:'5%',marginRight: '5%',padding:'0'}}>
                                <div className = 'col-sm-2' data-e2e="buy-in-filter">
                                    <h4 style={{marginTop : '20%'}}>BuyIn Filter : </h4>
                                </div>
                                <div className = 'col-sm-5' data-e2e="min">
                                    <label>Min </label>
                                    <input 
                                        type="text"
                                        value = {this.getBuyinFilterMin()} 
                                        onChange={event => this.buyInFilterChange('min', event.target.value)}
                                        className="form-control" 
                                        style = {{marginTop: '2%', marginBottom : '2%'}}
                                    />
                                    <span style={{ color : 'red' }} >
                                        {this.state.regExp_error}
                                    </span>
                                </div>
                                <div className = 'col-sm-5' data-e2e="max">
                                    <label>Max</label>
                                    <input 
                                        type="text"
                                        value = {this.getBuyinFilterMax()} 
                                        onChange={event => this.buyInFilterChange('max', event.target.value)}
                                        className="form-control" 
                                        style = {{marginTop: '2%', marginBottom : '2%'}}
                                    />
                                    <span style={{ color : 'red' }} >
                                        {this.state.regExp_error}
                                    </span>
                                </div>
                            </div>
                            <div className = 'row' style={{marginLeft:'5%',marginRight: '5%',padding:'0'}}>
                                <div className = 'col-md-12'>
                                    <div className = 'row' style={{border : '1px solid'}}>
                                        <div className = 'col-md-5 col-xs-5' >
                                            <label>Expected Percent</label>
                                        </div>
                                        <div className = 'col-md-4 col-xs-4'  >
                                            <label>Stage Percent</label>
                                        </div>
                                        <div className="col-md-3 col-xs-3"  style ={{paddingTop : '1%',paddingBottom : '1%'}} >
                                            <select 
                                                className = "form-control"
                                                onChange = {event => {
                                                    if(event.target.value != 'Copy Params') {
                                                        let selectedTournament = this.state.tournamentTypeTemplates.find(tournament => tournament.name == event.target.value);
                                                        this.setState({stageParams : selectedTournament.stageParams})
                                                    } else {
                                                        this.setState({stageParams : []})
                                                    }
                                                }}
                                            >
                                                <option data-e2e="copy-param">{'Copy Params'}</option>
                                                {this.state.tournamentTypeTemplates.map((tournament, key) => {
                                                    return <option key={key}>{tournament.name}</option>
                                                })}
                                            </select>
                                        </div>
                                        
                                        {this.state.stageParams.map((stageParam, key) => {
                                            return (
                                                <div key={key}>
                                                    <div className = 'col-md-5 col-xs-5' data-e2e="expexted-percentage">
                                                        <input
                                                            type="text"
                                                            value = {stageParam.expectedPercent}
                                                            onChange = {this.onExpectedPercentChange(key)}
                                                            className="form-control"
                                                            style = {{marginTop: '2%', marginBottom : '2%'}}
                                                        />
                                                    </div>
                                                    <div className = 'col-md-5 col-xs-5' data-e2e="stage-percentage" >
                                                        <input 
                                                            type="text"
                                                            value = {stageParam.stagePercent}
                                                            onChange = {this.onStagePercentChange(key)}
                                                            className="form-control" 
                                                            style = {{marginTop: '2%', marginBottom : '2%'}}
                                                        />
                                                    </div>
                                                    <button 
                                                        type="button" 
                                                        style={{paddingTop : '3%'}}
                                                        onClick = {this.removeStageParams(key)}
                                                        className="btn btn-link col-md-2 col-xs-2"
                                                        data-e2e="param-remove"
                                                    >
                                                    Remove
                                                    </button>
                                                </div>
                                            )
                                        })}
                                        <button 
                                            style = {{
                                                margin : '2%'
                                            }}
                                            onClick = {this.addStageParams}
                                            type="button" 
                                            className="btn btn-info col-md-3 col-xs-3"
                                            data-e2e="add-params"
                                        >
                                            Add Parameter
                                        </button>
                                        <span style={{color : 'red'}} className='col-md-9 col-xs-9'>
                                        {this.state.stageParams_error}  
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className = 'row' style={{marginLeft:'5%',marginRight: '5%',padding:'0'}}>
                                <button data-e2e="add-button"
                                    type="button" 
                                    className={"btn btn-primary col-md-5 col-xs-5 "}
                                    style ={{
                                        marginTop : '2%',
                                    }}
                                    onClick = {this.postData}
                                >
                                    {this.state.type}
                                </button>
                                <div className = 'col-md-2 col-xs-2'/>
                                <button data-e2e="cancel"
                                    type="button" 
                                    className="btn btn-primary col-md-5 col-xs-5"
                                    style ={{
                                        marginTop : '2%',
                                    }}
                                    onClick = {_ => this.setState({redirect : true})}
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </Paper>
                </div>
            </div>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
      setHeaderTitle : ( newTitle ) => dispatch(actions.setHeaderTitle( newTitle ))
    }
  };
  
  export default connect(null, mapDispatchToProps)(TournamentOverlayTypeUpsert);


/** WEBPACK FOOTER **
 ** ./src/components/TournamentOverlay/TournamentOverlayTypeUpsert.js
 **/